module.exports = __webpack_public_path__ + "static/media/vail-20.d36eedcd.jpg";